import React from 'react';
import classNames from 'classnames';
import type { GatsbyImageProps } from 'gatsby-plugin-image';

import { StaticImage } from './Image';

export enum SpriteName {
  CARD_MASTERCARD = 'sprite-logo-mastercard-xs',
  CARD_VISA = 'sprite-logo-visa-xs',
  CEBIA_RGB = 'sprite-cebia',
  CEBIA_MONO = 'sprite-logo-cebia',
  EYE = 'sprite-eye',
  FILTER_WHITE = 'sprite-filter-white',
  FILTER = 'sprite-filter',
  GOOGLE = 'sprite-logo-google',
  HOPPYGO_RGB = 'sprite-hoppygo-orange-logo',
  HOPPYGO_MONO = 'sprite-hoppygo-white-logo',
  HOPPYGO_ICON_RGB = 'sprite-hoppygo-orange-logo-notext',
  HOPPYGO_ICON_MONO = 'sprite-logo-noText',
  INFO = 'sprite-info',
  PHOTO_BACK = 'sprite-photo-back',
  PHOTO_CAMERA = 'sprite-photo-camera',
  PHOTO_FRONT = 'sprite-photo-front',
  PHOTO_LEFT = 'sprite-photo-left',
  PHOTO_LEFT_CORNER = 'sprite-photo-leftcorner',
  PHOTO_LEFT_CORNER_BACK = 'sprite-photo-leftcorner-back',
  PHOTO_RIGHT = 'sprite-photo-right',
  PHOTO_RIGHT_CORNER = 'sprite-photo-rightcorner',
  PHOTO_RIGHT_CORNER_BACK = 'sprite-photo-rightcorner-back',
  PHOTO_SEAT = 'sprite-photo-seat',
  PHOTO_STEERING_WHEEL = 'sprite-photo-steeringwheel',
  PLAY = 'sprite-play-btn',
  PLUS = 'sprite-plus',
  ROUND_REMOVE = 'sprite-round-remove',
  UNIQA_RGB = 'sprite-uniqa',
  UNIQA_MONO = 'insurance/uniqa_logo_mono',
  UNIQA_BLACK_ONELINE = 'logo_uniqa_black_oneline',
  SKODA_DIGILAB_RGB = 'skodaautodigilab',
  SKODA_DIGILAB_MONO = 'skodaautodigilab_white',
  SKODA_DIGILAB_BLACK = 'skodaautodigilab_black',
  SKODA_DIGILAB_BLACK_ONELINE = 'skodaautodigilab_black_oneline',
}

interface Props extends Partial<Omit<GatsbyImageProps, 'image'>> {
  name: SpriteName | string;
}

export function Sprite({ name, ...props }: Props) {
  return <StaticImage alt="sprite image" name={name} {...props} className={classNames('sprite', props.className)} />;
}
